import ClearIcon from "@mui/icons-material/Clear";
import DialpadIcon from "@mui/icons-material/Dialpad";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";

import PatientSearch from "components/patient-search";
import useSunoDialer from "components/suno-dialer/use-suno-dialer.hook";

import DigitButton from "../digit-button.component";
import SelectedPatient from "./selected-patient.component";

export default function SearchPatientTab() {
  const {
    outgoingCall,
    handleToggleShowPatients,
    handleChangeOutgoingCallPatient
  } = useSunoDialer();

  return (
    <Stack spacing={1.5} width="100%" alignItems="center">
      <PatientSearch
        minWidth={10}
        placeholder="Search patients"
        onPatientSelected={(patient) => {
          handleChangeOutgoingCallPatient(patient);
        }}
        disableClearable
        sx={{
          width: "300px",
          background: "#fff",
          borderRadius: "8px"
        }}
      />

      <SelectedPatient />

      <Stack
        direction="row"
        justifyContent="space-between"
        width="100%"
        pr={1.8}
        boxSizing="border-box"
      >
        <Tooltip title="Clear patient search">
          <Box sx={{ opacity: outgoingCall?.patient ? 1 : 0 }}>
            <DigitButton
              title={<ClearIcon />}
              onClick={() => {
                handleChangeOutgoingCallPatient(undefined);
              }}
              sx={{
                background: "hsla(272, 18%, 48%, 0.95)",
                boxShadow: "none",
                transform: "scale(0.7)"
              }}
            />
          </Box>
        </Tooltip>
        <DigitButton
          title={
            outgoingCall?.displayPatients ? <DialpadIcon /> : <PeopleAltIcon />
          }
          onClick={handleToggleShowPatients}
          sx={{
            background: "hsla(0, 0%, 100%, 0.85)",
            color: "hsla(272, 18%, 48%, 0.95)",
            "&:hover": {
              color: "hsla(271, 18%, 27%, 0.85)",
              background: "hsla(0, 0%, 100%,1)"
            }
          }}
        />
      </Stack>
    </Stack>
  );
}
